module.exports = __webpack_public_path__ + "images/5e05930978ab1d5078845fa3b320dfa1.jpg";


//////////////////
// WEBPACK FOOTER
// ../public/images/gift-categories/top-under50.jpg
// module id = 1095
// module chunks = 0